import { storeWrapper } from '../storeWrapper'
import { ospreyAPI } from '@repo/api/ospreyAPI'

const initialState = {}

export const useEmailStore = storeWrapper('useEmailStore', (set) => ({
  ...initialState,
  fetchEmailAuthUrl: async () => {
    return ospreyAPI({
      service: 'emails',
      endpoint: 'GraphApi/GetLoginUrl'
    })
  },
  deleteEmailTokens: async () => {
    return ospreyAPI({
      service: 'emails',
      method: 'DELETE',
      endpoint: 'GraphApi/DeleteGraphApiTokenByCurrentUser'
    })
  },
  fetchHasEmailSubscription: async () => {
    return ospreyAPI({
      service: 'emails',
      method: 'GET',
      endpoint: 'GraphApi/HasEmailSubscriptionByCurrentUser'
    })
  },
  deleteEmailSubscriptions: async () => {
    return ospreyAPI({
      service: 'emails',
      method: 'DELETE',
      endpoint: 'GraphApi/DeleteEmailSubscriptionByCurrentUser'
    })
  },
  createEmailSubscriptions: async () => {
    return ospreyAPI({
      service: 'emails',
      method: 'POST',
      endpoint: 'GraphApi/CreateEmailSubscriptionsByCurrentUser'
    })
  },
  reset: () => set(initialState)
}))
